export type Language = 'ko' | 'en' | 'ja' | 'zh';

export const translations: Record<Language, Record<string, string>> = {
  ko: {
    welcome_title: '만석',
    welcome_subtitle: '전화번호를 입력하고 대기 등록을 하세요',
    welcome_button: '대기 등록',
    welcome_button_takeout: '메뉴 선택',
    menu_title: '메뉴를 선택해주세요',
    menu_empty: '등록된 메뉴가 없습니다',
    menu_total: '총 결제금액',
    menu_next: '다음',
    menu_prev: '이전',
    phone_title: '전화번호를 입력해주세요',
    phone_prev: '이전',
    phone_next: '다음',
    party_title: '인원수를 선택해주세요',
    party_submit: '등록하기',
    party_submitting: '등록 중...',
    complete_number: '대기번호',
    complete_unit: '번',
    complete_ahead: '앞에 {count}팀 대기 중',
    complete_time: '약 {minutes}분 소요 예상',
    complete_notice: '순서가 되면 카카오톡으로 알려드립니다',
    complete_return: '{seconds}초 후 처음 화면으로 돌아갑니다',
    error_phone: '전화번호를 정확히 입력해주세요',
    error_closed: '현재 대기가 마감되었습니다',
    numpad_clear: 'C',
    numpad_delete: '\u2190',
    order_dine_in: '매장식사',
    order_takeout: '포장',
    ad_label: '광고',
    ad_suggestion: '대기 중 시간을 보내기 좋은 곳',
    lang_select: '언어 선택',
    waiting_current: '현재 웨이팅',
    waiting_estimated: '예상 시간',
    waiting_takeout: '포장 웨이팅',
    waiting_takeout_estimated: '포장 예상',
    unit_team: '팀',
    unit_minutes: '분',
  },
  en: {
    welcome_title: 'MANSUK',
    welcome_subtitle: 'Enter your phone number to join the waitlist',
    welcome_button: 'Join Waitlist',
    welcome_button_takeout: 'Select Menu',
    menu_title: 'Please select menu',
    menu_empty: 'No menu available',
    menu_total: 'Total',
    menu_next: 'Next',
    menu_prev: 'Back',
    phone_title: 'Please enter your phone number',
    phone_prev: 'Back',
    phone_next: 'Next',
    party_title: 'Select party size',
    party_submit: 'Submit',
    party_submitting: 'Submitting...',
    complete_number: 'Waiting No.',
    complete_unit: '',
    complete_ahead: '{count} parties ahead',
    complete_time: 'Estimated wait: {minutes} min',
    complete_notice: 'We will notify you via KakaoTalk',
    complete_return: 'Returning to home in {seconds}s',
    error_phone: 'Please enter a valid phone number',
    error_closed: 'Waitlist is currently closed',
    numpad_clear: 'C',
    numpad_delete: '\u2190',
    order_dine_in: 'Dine-in',
    order_takeout: 'Takeout',
    ad_label: 'AD',
    ad_suggestion: 'Places to visit while waiting',
    lang_select: 'Language',
    waiting_current: 'Now Waiting',
    waiting_estimated: 'Est. Wait',
    waiting_takeout: 'Takeout Wait',
    waiting_takeout_estimated: 'Takeout Est.',
    unit_team: 'parties',
    unit_minutes: 'min',
  },
  ja: {
    welcome_title: '満席',
    welcome_subtitle: '電話番号を入力してウェイティング登録',
    welcome_button: 'ウェイティング登録',
    welcome_button_takeout: 'メニュー選択',
    menu_title: 'メニューを選択してください',
    menu_empty: '登録されたメニューがありません',
    menu_total: '合計',
    menu_next: '次へ',
    menu_prev: '戻る',
    phone_title: '電話番号を入力してください',
    phone_prev: '戻る',
    phone_next: '次へ',
    party_title: '人数を選択してください',
    party_submit: '登録する',
    party_submitting: '登録中...',
    complete_number: '待ち番号',
    complete_unit: '番',
    complete_ahead: '前に{count}組がお待ちです',
    complete_time: '予想待ち時間：約{minutes}分',
    complete_notice: 'カカオトークでお知らせします',
    complete_return: '{seconds}秒後にホーム画面に戻ります',
    error_phone: '正しい電話番号を入力してください',
    error_closed: '現在ウェイティングは終了しました',
    numpad_clear: 'C',
    numpad_delete: '\u2190',
    order_dine_in: '店内飲食',
    order_takeout: 'テイクアウト',
    ad_label: '広告',
    ad_suggestion: '待ち時間におすすめの場所',
    lang_select: '言語選択',
    waiting_current: '現在の待ち',
    waiting_estimated: '予想時間',
    waiting_takeout: 'テイクアウト待ち',
    waiting_takeout_estimated: 'テイクアウト予想',
    unit_team: '組',
    unit_minutes: '分',
  },
  zh: {
    welcome_title: '满席',
    welcome_subtitle: '输入手机号码加入等候名单',
    welcome_button: '排队等候',
    welcome_button_takeout: '选择菜单',
    menu_title: '请选择菜单',
    menu_empty: '暂无菜单',
    menu_total: '总计',
    menu_next: '下一步',
    menu_prev: '上一步',
    phone_title: '请输入手机号码',
    phone_prev: '上一步',
    phone_next: '下一步',
    party_title: '请选择人数',
    party_submit: '提交',
    party_submitting: '提交中...',
    complete_number: '等候号码',
    complete_unit: '号',
    complete_ahead: '前面还有{count}桌在等候',
    complete_time: '预计等候时间：约{minutes}分钟',
    complete_notice: '轮到您时将通过KakaoTalk通知',
    complete_return: '{seconds}秒后返回首页',
    error_phone: '请输入正确的手机号码',
    error_closed: '目前已停止排队',
    numpad_clear: 'C',
    numpad_delete: '\u2190',
    order_dine_in: '堂食',
    order_takeout: '外带',
    ad_label: '广告',
    ad_suggestion: '等候时推荐去处',
    lang_select: '选择语言',
    waiting_current: '当前等候',
    waiting_estimated: '预计时间',
    waiting_takeout: '外带等候',
    waiting_takeout_estimated: '外带预计',
    unit_team: '桌',
    unit_minutes: '分钟',
  },
};
